"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var tombacIcon_1 = require("../tombacIcon");
function SvgJunction(props) {
    return (React.createElement("svg", tslib_1.__assign({ viewBox: "4 0 18 24" }, props),
        React.createElement("path", { d: "M8.315 17.769l4.348-3.778 4.362 3.765c.39.337.94.3 1.289-.087l2.332-2.573c.057-.06.108-.225.092-.417-.014-.154-.066-.259-.098-.283l-4.542-3.343 2.92-2.497c.047-.041.109-.193.096-.402-.01-.175-.068-.282-.096-.302l-2.379-1.537a.89.89 0 00-1.022.029l-2.988 2.155-3.148-2.318a.896.896 0 00-1.014-.045L6.083 7.604c-.02.012-.083.106-.097.289-.013.193.039.364.098.414l3.06 2.645-4.713 3.317c-.025.018-.081.11-.096.281-.017.195.034.358.091.42l2.617 2.734a.903.903 0 001.272.065", fill: "currentColor" })));
}
exports.default = tombacIcon_1.default('Junction')(SvgJunction);
//# sourceMappingURL=Junction.js.map